import { render, staticRenderFns } from "./LinhaDoTempo.vue?vue&type=template&id=65daee01&scoped=true&"
import script from "./LinhaDoTempo.vue?vue&type=script&lang=js&"
export * from "./LinhaDoTempo.vue?vue&type=script&lang=js&"
import style0 from "./LinhaDoTempo.vue?vue&type=style&index=0&id=65daee01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65daee01",
  null
  
)

export default component.exports